import React from 'react';
import {Header,Footer, PrivacyPolicy as PP} from '../components/components'

const PrivacyPolicy = () => {
  return (
    <>
    <Header/>
    <PP/>
    <Footer/>
    </>
  );
};

export default PrivacyPolicy;